import { useEffect } from 'react';

const SITE_URL = 'https://miestampita.com';

const setMetaTag = (attr, key, content) => {
  if (!content) return;
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

const setCanonicalLink = (href) => {
  let tag = document.head.querySelector('link[rel="canonical"]');
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', 'canonical');
    document.head.appendChild(tag);
  }
  tag.setAttribute('href', href);
};

// Sets a unique <title>, meta description, canonical URL and Open Graph/
// Twitter tags per route. public/index.html only provides the defaults
// used before this runs (e.g. crawlers that don't execute JS, or the
// instant before the first render).
export default function useSEO({ title, description, path = '', noindex = false }) {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;

    if (title) document.title = title;
    setMetaTag('name', 'description', description);
    setMetaTag('property', 'og:title', title);
    setMetaTag('property', 'og:description', description);
    setMetaTag('property', 'og:url', url);
    setMetaTag('name', 'twitter:title', title);
    setMetaTag('name', 'twitter:description', description);
    setCanonicalLink(url);
    setMetaTag('name', 'robots', noindex ? 'noindex, follow' : 'index, follow');
  }, [title, description, path, noindex]);
}
